import { createGlobalStyle, css } from 'styled-components';
import { px2em } from './functions';
import { device, hoverActiveFocus } from './mixins';
import { baseFontSize, baseLineHeight, kskTheme } from './themes';

const GlobalStyle = createGlobalStyle`
// LEGACY FIX

.MuiIconButton-label {
  color: rgba(0, 0, 0);
}

.MuiInputLabel-root {
  color: rgba(0, 0, 0);
}

.MuiDialog-root .MuiDialogContent-root.MuiDialogContent-root {
  padding-top: 24px;
}

.MuiDialog-root .svg-inline--fa {
  font-size: revert;
  width: revert;
}

.MuiDialog-root legend {
  margin-top: 0;
}

.MuiDialog-root td {
  border-bottom: revert;
  padding: revert;
}

.MuiDialog-root td:not([align]):not(.condicao-financeira td) {
  text-align: revert;
}

.MuiDialog-root tr:hover td {
  background-image: revert;
}

.MuiDialog-root th {
  background-color: revert;
}

.MuiDialog-root {
  .historico__legenda-ul label {
    color: revert;
  }
}

.MuiDialog-root {
  .MuiDialogTitle-root, .formula-canvas__header {
    background-color: #1351B4;
  }

  .ksk-input-rico {
    .note-toolbar {
      background-color: revert;
      border-bottom: revert;
    }

    .note-btn {
      border: 0px solid #dae0e5;
    }

    .note-dropdown-menu {
      width: max-content;
    }

    h1, h2, h3, h4, h5, h6 {
      text-transform: revert;
    }
    
    h1 {
      font-size: 34.832px;
    }

    p:not(.Mui-error) {
      color: black;
      font-size: 14px;
      line-height: 1.5;
      margin-top: 0;
      margin-bottom: 1rem;
    }

    // blockquote {
    //   all: revert
    // }

    // pre {
    //   all: revert;
    // }

    // h2, h3, h4, h5, h6 {
    //   all: revert;
    // }
  }
}

.MuiDialogTitle-root {
  background-color: #1351B4;
}

.MuiRadio-colorPrimary.Mui-checked.Mui-disabled {
  color: revert;
}

.ksk-radio__readonly {
  cursor: not-allowed;
  .MuiFormControlLabel-root {
    cursor: not-allowed;
  }
  .MuiFormControlLabel-label,
  .MuiFormControlLabel-label.Mui-disabled {
    color: rgba(0, 0, 0, 0.38) !important;
    -webkit-text-fill-color: rgba(0, 0, 0, 0.38) !important;
  }
  .MuiRadio-root,
  .MuiRadio-root.Mui-checked,
  .MuiRadio-root.Mui-disabled {
    color: rgba(0, 0, 0, 0.38) !important;
  }
}

.MuiFormControl-root .MuiChip-root.MuiChip-colorPrimary {
  -webkit-text-fill-color: #fff;
  background-color: #1351B4;
}

/* Campos desabilitados: Input, Select, Autocomplete, etc. */
.MuiInputBase-root.Mui-disabled,
.MuiInputBase-input.Mui-disabled,
.MuiInputLabel-root.Mui-disabled,
.MuiFormLabel-root.Mui-disabled,
.MuiSelect-select.Mui-disabled,
.MuiAutocomplete-root .MuiInputBase-input.Mui-disabled,
.MuiSvgIcon-root.MuiSelect-icon.Mui-disabled {
  color: rgba(0, 0, 0, 0.6) !important;
  fill: rgba(0, 0, 0, 0.6) !important;
  -webkit-text-fill-color: rgba(0, 0, 0, 0.6) !important;
  cursor: not-allowed !important;
}

/* Restaura a borda pontilhada nativa do MUI para campos desabilitados */
.MuiInput-underline.Mui-disabled:before {
  border-bottom-style: dotted !important;
}

/* Garante o cursor not-allowed no container pai (quando o input não preenche tudo) */
.MuiFormControl-root.Mui-disabled *,
.MuiInputBase-root.Mui-disabled * {
  cursor: not-allowed !important;
}

.MuiFormHelperText-root p {
  font-size: revert;
  color: revert;
  font-size: revert;
  font-weight: revert;
  line-height: revert;
  margin-bottom: revert;
}

.header-search {
  justify-content: end;
}

.header-search .svg-inline--fa {
  font-size: revert;
  width: revert;
}

.header-login .svg-inline--fa {
  font-size: revert;
  width: revert;
}

[hidden] {
  display: none !important;
}

.legacy {
  .resultado-datatable-container {
    .align-right {
      font-family: Courier New, Courier, monospace;
    }
  }
  
  .ksk-box__body .ksk-datatable__row:hover {
    background-color: #D9E3F3;
  }
  
  .ksk-box__body .ksk-datatable__row:nth-child(2n):hover {
    background-color: #D9E3F3;
  }

  .svg-inline--fa {
    font-size: revert;
    width: revert;
  }

  a:not(:disabled):hover {
    background-image: revert;
  }
  
  img {
    max-width: revert;
  }

  legend {
    font-weight: revert;
    line-height: revert;
    margin-bottom: revert;
    margin-top: revert;
  }

  summary {
    cursor: pointer;
  }

  th {
    background-color: revert;
  }

  tr:hover td {
    background-image: revert;
  }
  
  tbody td {
    border-bottom: revert;
  }

  .ksk-input-rico {
    .note-toolbar {
      background-color: revert;
      border-bottom: revert;
    }

    .note-btn {
      border: 0px solid #dae0e5;
    }

    .note-dropdown-menu {
      width: max-content;
    }

    h1, h2, h3, h4, h5, h6 {
      text-transform: revert;
    }
    
    h1 {
      font-size: 34.832px;
    }

    p:not(.Mui-error) {
      color: black;
      font-size: 14px;
      line-height: 1.5;
      margin-top: 0;
      margin-bottom: 1rem;
    }

    // blockquote {
    //   all: revert
    // }

    // pre {
    //   all: revert;
    // }

    // h2, h3, h4, h5, h6 {
    //   all: revert;
    // }
  }
}

// LEGACY FIX END

html,
body {
  // font-family: 'Source Sans Pro', sans-serif;
  font-size: ${baseFontSize};
  line-height: ${ baseLineHeight };
  height: 100%;
  min-height: 80vh;
  min-width: 320px;
  margin: 0;
  scroll-behavior: smooth;
}

a,
button {
  cursor: pointer;
  
}

a, button, main, footer, input, select {
  ${hoverActiveFocus(css`
    outline: none;
  `)}
}

a {
  color: ${kskTheme.linkColor};
  text-decoration: none;

  ${hoverActiveFocus(css`
    color: ${kskTheme.hoverLinkColor};
    text-decoration: none;
  `)}
}

h1, h2, h3, h4, h5, h6 {
  font-weight: 500;
  line-height: 1.1;
  color :inherit;
}

.list-style-none {
  list-style: none;
}

.text-selection-disabled {
  user-select: none;
}

.cursor-pointer.cursor-pointer {
  cursor: pointer;
}

.cursor-move.cursor-move {
  cursor: move;
}

.cursor-help.cursor-help {
  cursor: help;
}

.cursor-not-allowed.cursor-not-allowed {
  cursor: not-allowed;
}

.small-text {
  font-size: .8em;
}

.large-text {
  font-size: 1.35em;
}

/* h3, h4, h5, h6 {
  font-size: px2em(14);
}
*/

var {
  font-style: normal;
}

.monospace {
  font-family: Courier New, Courier, monospace;
  font-size: 0.928571429rem;
}

.display-block.display-block {
  display: block;
}

.display-none.display-none {
  display: none;
}

.inline-block.inline-block {
  display: inline-block;
}

.normal.normal {
  font-weight: normal;
}

.bold.bold {
  font-weight: bold;
}

.semibold.semibold {
  font-weight: 600;
}

.italic.italic {
  font-style: italic;
}

.underline.underline {
  text-decoration: underline;
}

.align-center.align-center {
  text-align: center;
}

.align-left.align-left {
  text-align: left;
}

.align-right.align-right {
  text-align: right;
}

.justify.justify {
  text-align: justify;
}

/*===================================================================================*/

.theme-text-color {
  color: ${kskTheme.themeColor};
}

.text-color-over-theme-color {
  color: ${kskTheme.extOverThemeColor};
}

.default-text-color {
  color: ${kskTheme.text};
}

.default-background-color {
  background-color: ${kskTheme.defaultBackground};
}

.dark-bg {
  background-color: ${kskTheme.darkText};
}

.dark-text {
  color: ${kskTheme.darkText};
}

.light-text {
  color: ${kskTheme.lightText};
}

.disabled-text {
  color: ${kskTheme.disabledText};
}

.disclaimer-text {
  color: ${kskTheme.disclaimerText};
}

.primary-text {
  color: ${kskTheme.primaryColor}
}

.primary-bg {
  background-color: #1351B4;
  // background-color: ${kskTheme.primaryColor};
}

.secondary-text {
  color: ${kskTheme.secondaryColor}
}

.secondary-bg {
  background-color: ${kskTheme.secondaryColor};
}

.success-text {
  color: ${kskTheme.successColor}
}

.success-bg {
  background-color: ${kskTheme.successColor}
}

.warn-text {
  color: ${kskTheme.warnColor}
}

.warn-bg {
  background-color: ${kskTheme.warnColor};
}

.danger-text {
  color: ${kskTheme.dangerColor}
}

.danger-bg {
  background-color: ${kskTheme.dangerColor};
}

.info-text {
  color: ${kskTheme.infoColor}
}

.info-bg {
  background-color: ${kskTheme.infoColor};
}

.text-over-primary {
  color: ${kskTheme.textOverPrimaryColor};
}

.text-over-secondary {
  color: ${kskTheme.textOverSecondaryColor};
};

.text-over-success {
  color: ${kskTheme.textOverSuccessColor};
}

.text-over-warn {
  color: ${kskTheme.textOverWarnColor};
}

.text-over-danger {
  color: ${kskTheme.textOverDangerColor};
}

.text-over-info {
  color: ${kskTheme.textOverInfoColor};
}

/*=====================================================================================*/

${
  /** Classes utilitárias de padding e margin
  p = padding, m = margir
  t = top; r = right; b = bottom; l = left
  v = vertical; h = horizontal
  Número que segue é o valor da propriedade na unidade 'em'

  ex: p-025 = padding de 0.25em
      ml-05 = margin-left de 0.5em
      mh-075 = margin horizontal (left e right) de 0.75em
      pv-125 = padding vertical (top e bottom) de 1.25em
 */
  [0, .25, .5, .75, 1, 1.25, 1.5, 1.75, 2].map(v => {
    const factor = `${v}`.replace('.', '');
    const marginClass = `m-${factor}`;
    const marginVClass = `mv-${factor}`;
    const marginHClass = `mh-${factor}`;
    const paddingClass = `p-${factor}`;
    const paddingVClass = `pv-${factor}`;
    const paddingHClass = `ph-${factor}`;
    const emValue = `${v}em`;
    return css`
      .${marginClass}.${marginClass} {
        margin: ${emValue};
      }

      .${marginVClass}.${marginVClass} {
        margin-top: ${emValue};
        margin-bottom: ${emValue};
      }

      .${marginHClass}.${marginHClass} {
        margin-left: ${emValue};
        margin-right: ${emValue};
      }

      .${paddingClass}.${paddingClass} {
        padding: ${emValue};
      }

      .${paddingVClass}.${paddingVClass} {
        padding-top: ${emValue};
        padding-bottom: ${emValue};
      }

      .${paddingHClass}.${paddingHClass} {
        padding-left: ${emValue};
        padding-right: ${emValue};
      }

      ${
        ['top', 'right', 'bottom', 'left'].map(pos =>  {
          const marginPosClass = `m${pos.substring(0,1)}-${factor}`;
          const paddingPosClass = `p${pos.substring(0,1)}-${factor}`;
          return css`
            .${marginPosClass}.${marginPosClass} {
              margin-${pos}: ${emValue};
            }
            .${paddingPosClass}.${paddingPosClass} {
              padding-${pos}: ${emValue};
            }
        `})
      }
    `})
}

.screen-reader,
.visually-hidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.disabled-text {
  color: ${kskTheme.disabledText};
}

.disclaimer-text.disclaimer-text {
  color: ${kskTheme.disclaimerText};
}

.cpf {
  font-family: monospace;
  letter-spacing: ${px2em(-2)};
}

.full-width {
  width: 100%;
}

.display-flex.display-flex {
  display: flex;
}

.flex-direction-column.flex-direction-column {
  flex-direction: column;
}

.flex-end.flex-end {
  align-items: flex-end;
}

.flex-center.flex-center {
  align-items: center;
}

.justify-content-center.justify-content-center {
  justify-content: center;
}

.gap-05em,
.grid-gap-05em {
  grid-gap: 0.5em;
}

.gap-1em,
.grid-gap-1em {
  grid-gap: 1em;
}

.overflow-auto {
  overflow: auto;
}

.overflow-x-auto {
  overflow-x: auto;
}

.overflow-y-auto {
  overflow-y: auto;
}

.mat-dialog-container {
  padding: 0!important;
  -moz-border-radius:7px!important;
  -webkit-border-radius:7px!important;
  border-radius:17px!important;
  border: 1px solid black!important;
}

#info-modal:hover {
  -moz-box-shadow:3px 1px 1px 1px;
  -webkit-box-shadow:3px 1px 1px 1px;
  box-shadow: 3px 1px 1px 1px;
}

.bgBlue {
  background-color: blue !important;
}

.ellipsis {
  max-width: 100ch;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nowrap {
  white-space: nowrap;
}

.kskSimpleList {
  padding-left: 2em;
  margin-bottom: 0;
}

@keyframes ksk-animation-error-shake {
  from,
  to {
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translate3d(-2px, 0, 0);
  }

  20%,
  40%,
  60%,
  80% {
    transform: translate3d(2px, 0, 0);
  }
}

.ksk-animation-error-shake {
  animation: ksk-animation-error-shake 0.5s infinite;
}

.bg-red.bg-red {
  background: #f005;
}

.white-space-pre.white-space-pre {
  white-space: pre;
}

.white-space-pre-wrap {
  white-space: pre-wrap;
}

.tagify__dropdown.tagify__dropdown {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  padding:.25em 0;

  &[position=text] {
    box-shadow: 0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%);
    font-size: 1em;
  }
}

.tagify__dropdown__wrapper.tagify__dropdown__wrapper {
  border: none;
}

.tagify__dropdown__item.tagify__dropdown__item {
  font-size: 1em;
  padding: .75em 1.5em;

  color: ${kskTheme.text};

  &--active {
    background-color: ${kskTheme.dropdownHoverColor};
    color: ${kskTheme.text}
  }
}

.pointer-events-none {
  pointer-events: none;
}

.dropdown-toggle::after {
  display: none !important;
}

.ksk-input-rico {
  .ksk-input-rico__editor-wrapper {
    overflow: hidden;
  }

  .quill {
    display: flex;
    flex-direction: column;
    height: 100%;
    margin-bottom: 0;
  }

  .ql-toolbar.ql-snow {
    flex: 0 0 auto;
  }

  .ql-container.ql-snow {
    flex: 1 1 auto;
    min-height: 0;
  }

  .ksk-input-rico__helper.MuiFormHelperText-root {
    margin-left: 14px;
    margin-right: 0;
    margin-top: 3px;
  }
    
  .note-editor.note-frame .note-editing-area .note-editable[contenteditable=false],
  .note-editor.note-airframe .note-editing-area .note-editable[contenteditable=false] {
    background-color: #f6f6f6;
    cursor: not-allowed;
    word-wrap: anywhere;
  }

  &--error {
    .ql-toolbar.ql-snow {
      border-color: #f44336;
      border-width: 2px 2px 1px 2px;
    }

    .ql-container.ql-snow {
      border-color: #f44336;
      border-width: 0 2px 2px 2px;
    }
  }

  &--readonly {
    .note-btn {
      cursor: not-allowed;
    }
  }
}

.ksk-form__helper {
  padding: 0.5em 0px 0.5em .75em;
  flex-direction: row;
  gap: 0.3333em;
  align-items: center;
  
  color: rgba(0, 0, 0, 0.54);
  color: #555;
  margin: 0;
  display: flex;
  font-size: 0.75rem;
  margin-top: 3px;
  text-align: left;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  line-height: 1.66;
  white-space: pre-wrap;

  letter-spacing: 0.03333em;
}

.ksk-form__helper-info {
  font-size:1.25em;
}

.ksk-form__helper--desktop-only {
  display: none;
}

@media only screen and (min-width: 992px) {
  .ksk-form__helper--desktop-only {
    display: flex;
  }
}


// input,
// textarea,
// .ksk-input,
// .ksk-autocomplete,
// .ksk-input-rico,
// .ksk-output-field,
// .note-editable,
// .MuiInput-input,
// .MuiInputBase-input,
// .MuiAutocomplete-input,
// div[role="textbox"] {
//   cursor: pointer !important;
// }

// select,
// .ksk-select,
// .MuiSelect-select,
// div[role="combobox"] {
//   cursor: pointer !important;
// }

// button,
// .ksk-button,
// div[role="button"] {
//   cursor: pointer !important;
// }

.read-only-mode {
  input:not(.ignore-read-only):not(.ignore-read-only *),
  textarea:not(.ignore-read-only):not(.ignore-read-only *),
  select:not(.ignore-read-only):not(.ignore-read-only *),
  .ksk-input:not(.ignore-read-only):not(.ignore-read-only *),
  .ksk-select:not(.ignore-read-only):not(.ignore-read-only *),
  .ksk-autocomplete:not(.ignore-read-only):not(.ignore-read-only *),
  .ksk-input-rico:not(.ignore-read-only):not(.ignore-read-only *),
  .ksk-output-field:not(.ignore-read-only):not(.ignore-read-only *),
  .note-editable:not(.ignore-read-only):not(.ignore-read-only *),
  .MuiInput-input:not(.ignore-read-only):not(.ignore-read-only *),
  .MuiInputBase-input:not(.ignore-read-only):not(.ignore-read-only *),
  .MuiInputBase-root:not(.ignore-read-only):not(.ignore-read-only *),
  .MuiSelect-select:not(.ignore-read-only):not(.ignore-read-only *),
  .MuiAutocomplete-input:not(.ignore-read-only):not(.ignore-read-only *),
  .MuiInputLabel-root:not(.ignore-read-only):not(.ignore-read-only *),
  .MuiFormLabel-root:not(.ignore-read-only):not(.ignore-read-only *),
  .MuiSvgIcon-root:not(.ignore-read-only):not(.ignore-read-only *),
  div[role="textbox"]:not(.ignore-read-only):not(.ignore-read-only *),
  div[role="combobox"]:not(.ignore-read-only):not(.ignore-read-only *) {
    color: rgba(0, 0, 0, 0.38) !important;
    fill: rgba(0, 0, 0, 0.38) !important;
    -webkit-text-fill-color: rgba(0, 0, 0, 0.38) !important;
    cursor: not-allowed !important;
  }

  .MuiInput-underline:not(.ignore-read-only):not(.ignore-read-only *):before {
    border-bottom-style: dotted !important;
  }

  /* força botão a continuar sendo clicável */
  button,
  .ksk-button,
  div[role="button"],
  a {
    cursor: pointer !important;
  }
}
`;

export default GlobalStyle;
